var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DotMenuItem",class:_vm.rootClasses,on:{"click":_vm.onDotItemClick}},[(_vm.icon)?_c('div',{staticClass:"IconWrap"},[_c(_vm.iconToUse,{tag:"component"})],1):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }